import {
    PublicClientApplication, AuthenticationResult, Configuration,
    LogLevel, AccountInfo, InteractionRequiredAuthError, EndSessionRequest
} from "@azure/msal-browser";

const MSAL_CONFIG: Configuration = {
    auth: {
        clientId: `${process.env.REACT_APP_CLIENT_ID}`,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}/`,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

export class AuthService {

    private apiRequest = {
        scopes: [`${process.env.REACT_APP_API_SCOPE}/.default`],
        forceRefresh: false,
        redirectUri: window.location.origin + "/signin"
    };
    private myMSALObj: PublicClientApplication;
    private account: AccountInfo | undefined | null;

    constructor() {
        this.myMSALObj = new PublicClientApplication(MSAL_CONFIG);
    }

    public storage = localStorage;

    public loadAuthModule() {
        this.myMSALObj.handleRedirectPromise().then((resp: AuthenticationResult | null) => {
            this.handleResponse(resp);
        }).catch(console.error);
    }

    public loginRedirect() {
        this.storage.setItem("signing-in", "true");
        this.myMSALObj.loginRedirect(this.apiRequest);
    }

    public logout(): void {
        const logOutRequest: EndSessionRequest = {
            account: this.account
        };

        this.storage.removeItem("authenticated");
        this.myMSALObj.logoutRedirect(logOutRequest);
    }

    public async getToken(): Promise<string> {
        return this.getTokenRedirect(this.apiRequest);
    }

    private handleResponse(response: AuthenticationResult | null) {
        if (response !== null) {
            this.storage.setItem("authenticated", "true");
            this.account = response.account;
        } else {
            this.account = this.getAccount();
        }
    }

    private getAccount(): AccountInfo {
        const currentAccounts = this.myMSALObj.getAllAccounts();
        if (currentAccounts === null || currentAccounts.length === 0) {
            throw new Error("No accounts detected");
        }

        return currentAccounts[0];
    }

    private async getTokenRedirect(request: any): Promise<string> {
        request.account = this.getAccount();
        try {
            const response: AuthenticationResult = await this.myMSALObj.acquireTokenSilent(request);
            return response.accessToken;
        } catch (e) {
            console.log("silent token acquisition fails.");
            if (e instanceof InteractionRequiredAuthError) {
                console.log("acquiring token using redirect");
                return this.myMSALObj.acquireTokenRedirect(request).then((_) => {
                    return "";
                }).catch((err) => {
                    console.error(err);
                    return "";
                });
            } else {
                console.error(e);
                this.loginRedirect();
            }
        }
        return "";
    }
}

export default AuthService;
